<template>
  <div class="z-40 fixed bottom-0 start-0 w-full h-full bg-black/40 flex items-end">
    <div class="w-full md:h-24 bg-white text-brand-black-secondary">
      <div
        class="soar-container py-1.5 md:py-3 h-full flex flex-col md:flex-row gap-4 justify-between"
      >
        <div class="flex-col gap-3">
          <h2 class="">{{ $t('cookieBannerMassage1') }}</h2>
          <p class="text-xs font-sans">{{ $t('cookieBannerMassage2') }}</p>
        </div>
        <div class="w-full md:w-1/3 flex justify-center items-center">
          <button
            class="px-3 py-1.5 text-center rounded-md bg-primary/80 hover:bg-primary flex items-center gap-x-2 hover:scale-[1.02] active:scale-100 disabled:bg-gray-300 disabled:hover:scale-95 disabled:cursor-not-allowed text-white text-xs font-sans"
            @click="cookieBanner.setCookie()"
          >
            {{ $t('iGotIt') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import useCookieBanner from '@/composables/useCookieBanner'

const cookieBanner = useCookieBanner()
</script>

<script>
export default {
  name: 'CookiePolicy'
}
</script>

<style lang="scss" scoped></style>
